// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   HomeReviewPage — learner stories with a stacked card deck
   Prefix: home_review_pg_ · no :root variables · no green
   ============================================================ */

.home_review_pg_section {
  position: relative;
  width: 100%;
  padding: 88px 0 96px;
  background: linear-gradient(135deg, #f4edff 0%, #ffffff 46%, #fff2ea 100%);
  font-family: "Sora", "Manrope", sans-serif;
  color: #0f0a2a;
  overflow: hidden;
  isolation: isolate;
}

.home_review_pg_section *,
.home_review_pg_section *::before,
.home_review_pg_section *::after {
  box-sizing: border-box;
}

/* soft glows */
.home_review_pg_section::before {
  content: "";
  position: absolute;
  z-index: -1;
  top: -140px;
  left: -160px;
  width: 460px;
  height: 460px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(106, 31, 194, 0.18) 0%, rgba(106, 31, 194, 0) 70%);
  pointer-events: none;
}

.home_review_pg_section::after {
  content: "";
  position: absolute;
  z-index: -1;
  right: -160px;
  bottom: -160px;
  width: 520px;
  height: 520px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(224, 168, 61, 0.24) 0%, rgba(224, 168, 61, 0) 70%);
  pointer-events: none;
}

.home_review_pg_container {
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
  align-items: center;
  column-gap: 72px;
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 24px;
}

/* ============================================================
   Left: copy
   ============================================================ */

.home_review_pg_copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
}

.home_review_pg_eyebrow {
  margin-bottom: 16px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #4a1a9e;
}

.home_review_pg_heading {
  max-width: 520px;
  margin: 0 0 18px;
  font-size: clamp(30px, 4vw, 50px);
  font-weight: 800;
  line-height: 1.12;
  letter-spacing: -0.02em;
  color: #0f0a2a;
  text-wrap: balance;
}

.home_review_pg_subtext {
  max-width: 440px;
  margin: 0 0 30px;
  font-size: 16.5px;
  line-height: 1.7;
  color: #5d5978;
}

.home_review_pg_cta {
  position: relative;
  padding: 16px 32px;
  border: 0;
  border-radius: 10px;
  background: linear-gradient(100deg, #4a1a9e 0%, #6a1fc2 100%);
  box-shadow: 0 16px 32px rgba(74, 26, 158, 0.34);
  font-family: inherit;
  font-size: 15.5px;
  font-weight: 800;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  isolation: isolate;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

/* gold sweep on hover */
.home_review_pg_cta::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background: linear-gradient(100deg, #e0a83d 0%, #f2c15c 100%);
  transform: translateX(-101%);
  transition: transform 0.45s cubic-bezier(0.22, 1, 0.36, 1);
}

.home_review_pg_cta:hover {
  color: #3b003d;
  transform: translateY(-3px);
  box-shadow: 0 20px 36px rgba(224, 168, 61, 0.42);
}

.home_review_pg_cta:hover::before {
  transform: translateX(0);
}

.home_review_pg_cta:active {
  transform: translateY(0) scale(0.97);
}

.home_review_pg_cta:focus-visible,
.home_review_pg_arrow:focus-visible,
.home_review_pg_dot:focus-visible {
  outline: 3px solid #e0a83d;
  outline-offset: 3px;
}

/* ============================================================
   Right: stacked card deck
   ============================================================ */

.home_review_pg_stage {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-width: 0;
  max-width: 620px;
  justify-self: end;
  padding: 30px 0 0 30px; /* room for the cards peeking out behind */
}

/* all cards share one grid cell, so the deck is as tall as the tallest card */
.home_review_pg_deck {
  display: grid;
  width: 100%;
  outline: none;
  touch-action: pan-y;
  perspective: 1400px;
}

.home_review_pg_deck:focus-visible {
  outline: 3px solid #e0a83d;
  outline-offset: 8px;
  border-radius: 24px;
}

.home_review_pg_card {
  grid-area: 1 / 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 30px 34px 28px;
  border-radius: 22px;
  background: #ffffff;
  border: 1px solid rgba(228, 220, 249, 0.9);
  box-shadow: 0 30px 70px rgba(74, 26, 158, 0.16), 0 3px 10px rgba(74, 26, 158, 0.05);
  transform-origin: 15% 95%;
  will-change: transform, opacity;
  transition:
    transform 0.95s cubic-bezier(0.22, 1, 0.36, 1),
    opacity 0.7s ease,
    box-shadow 0.7s ease;
}

/* where each card sits in the stack */
.home_review_pg_card_front {
  z-index: 4;
  opacity: 1;
  transform: translate3d(0, 0, 0) rotate(0deg) scale(1);
}

.home_review_pg_card_second {
  z-index: 3;
  opacity: 0.9;
  transform: translate3d(-18px, -16px, 0) rotate(-2.2deg) scale(0.97);
  box-shadow: 0 18px 40px rgba(74, 26, 158, 0.1);
}

.home_review_pg_card_third {
  z-index: 2;
  opacity: 0.55;
  transform: translate3d(-34px, -30px, 0) rotate(-4.2deg) scale(0.94);
  box-shadow: 0 12px 28px rgba(74, 26, 158, 0.07);
}

.home_review_pg_card_hidden {
  z-index: 1;
  opacity: 0;
  pointer-events: none;
  transform: translate3d(-46px, -40px, 0) rotate(-5.5deg) scale(0.9);
}

/* the card that just left: slides away to the left and fades */
.home_review_pg_card_out {
  z-index: 5;
  opacity: 0;
  pointer-events: none;
  transform: translate3d(-90px, 14px, 0) rotate(-9deg) scale(0.96);
}

/* ---------- Card content: rises in when a card reaches the front ---------- */

.home_review_pg_step {
  opacity: 0;
  transform: translateY(14px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.home_review_pg_card_front .home_review_pg_step {
  opacity: 1;
  transform: none;
  transition:
    opacity 0.7s ease calc(var(--s, 0) * 80ms + 280ms),
    transform 0.8s cubic-bezier(0.22, 1, 0.36, 1) calc(var(--s, 0) * 80ms + 280ms);
}

.home_review_pg_quote_icon {
  display: inline-flex;
  align-self: flex-start;
  margin-bottom: 18px;
  color: #f2a900;
}

.home_review_pg_outcome {
  align-self: flex-start;
  margin-bottom: 16px;
  padding: 5px 13px;
  border-radius: 999px;
  background: #ece2ff;
  font-size: 12px;
  font-weight: 700;
  color: #4a1a9e;
}

.home_review_pg_quote {
  flex-grow: 1;
  margin: 0 0 26px;
  font-size: 17px;
  line-height: 1.7;
  text-align: left;
  color: #1c1538;
  overflow-wrap: anywhere;
}

.home_review_pg_person {
  display: flex;
  align-items: center;
  gap: 14px;
}

.home_review_pg_avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  flex-shrink: 0;
  border-radius: 50%;
  background: linear-gradient(135deg, #4a1a9e 0%, #6a1fc2 100%);
  box-shadow: 0 8px 18px rgba(74, 26, 158, 0.3);
  font-size: 17px;
  font-weight: 800;
  color: #ffffff;
}

.home_review_pg_who {
  flex: 1 1;
  min-width: 0;
}

.home_review_pg_name {
  margin: 0;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.3;
  color: #0f0a2a;
}

.home_review_pg_role {
  margin: 2px 0 0;
  font-size: 12.5px;
  line-height: 1.4;
  color: #6b6784;
}

.home_review_pg_count {
  flex-shrink: 0;
  font-size: 12.5px;
  font-weight: 800;
  letter-spacing: 0.04em;
  color: #6b6784;
  font-variant-numeric: tabular-nums;
}

/* ---------- Controls ---------- */

.home_review_pg_controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 30px;
}

.home_review_pg_arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 46px;
  height: 46px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(74, 26, 158, 0.16);
  color: #1c1538;
  cursor: pointer;
  transition: transform 0.3s ease, background 0.3s ease, color 0.3s ease, box-shadow 0.3s ease;
  -webkit-tap-highlight-color: transparent;
}

.home_review_pg_arrow:hover {
  background: #4a1a9e;
  color: #ffffff;
  box-shadow: 0 14px 28px rgba(74, 26, 158, 0.34);
}

.home_review_pg_arrow:active {
  transform: scale(0.9);
}

.home_review_pg_dots {
  display: flex;
  align-items: center;
  gap: 8px;
}

.home_review_pg_dot {
  position: relative;
  width: 10px;
  height: 10px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: #d9ccf3;
  overflow: hidden;
  cursor: pointer;
  transition: width 0.45s cubic-bezier(0.22, 1, 0.36, 1), background 0.3s ease;
}

.home_review_pg_dot:hover {
  background: #bba6ea;
}

.home_review_pg_dot_active {
  width: 34px;
  background: #d9ccf3;
}

/* the active dot doubles as the autoplay timer */
.home_review_pg_dot_fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  border-radius: 999px;
  background: #4a1a9e;
}

.home_review_pg_dot_fill_run {
  width: 0;
  animation: home_review_pg_timer var(--ms, 6500ms) linear forwards;
}

@keyframes home_review_pg_timer {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

/* ============================================================
   Entrance (plays once when the section scrolls into view)
   ============================================================ */

.home_review_pg_reveal {
  opacity: 0;
  transform: translateY(28px);
  transition:
    opacity 0.8s ease var(--d, 0ms),
    transform 0.9s cubic-bezier(0.22, 1, 0.36, 1) var(--d, 0ms);
}

.home_review_pg_in .home_review_pg_reveal {
  opacity: 1;
  transform: none;
}

/* the cta keeps its own hover transition once revealed */
.home_review_pg_in .home_review_pg_cta.home_review_pg_reveal {
  transition:
    opacity 0.8s ease var(--d, 0ms),
    transform 0.3s ease,
    box-shadow 0.3s ease,
    color 0.3s ease;
}

.home_review_pg_reveal_deck {
  opacity: 0;
  transform: translateX(60px) rotate(2deg);
  transition:
    opacity 0.9s ease 0.3s,
    transform 1.1s cubic-bezier(0.22, 1, 0.36, 1) 0.3s;
}

.home_review_pg_in .home_review_pg_reveal_deck {
  opacity: 1;
  transform: none;
}

/* ============================================================
   Responsive — 1100 / 820 / 560 / 360
   ============================================================ */

@media (max-width: 1100px) {
  .home_review_pg_section {
    padding: 72px 0 80px;
  }

  .home_review_pg_container {
    column-gap: 44px;
  }

  .home_review_pg_card {
    padding: 26px 26px 24px;
  }

  .home_review_pg_quote {
    font-size: 16px;
  }
}

/* stack: copy on top, deck below */
@media (max-width: 900px) {
  .home_review_pg_section {
    padding: 60px 0 72px;
  }

  .home_review_pg_container {
    grid-template-columns: minmax(0, 1fr);
    row-gap: 44px;
  }

  .home_review_pg_heading,
  .home_review_pg_subtext {
    max-width: 640px;
  }

  .home_review_pg_stage {
    justify-self: center;
    max-width: 640px;
    padding: 28px 0 0 28px;
  }

  .home_review_pg_reveal_deck {
    transform: translateY(40px);
  }
}

@media (max-width: 560px) {
  .home_review_pg_section {
    padding: 48px 0 60px;
  }

  .home_review_pg_container {
    padding: 0 18px;
    row-gap: 34px;
  }

  .home_review_pg_subtext {
    margin-bottom: 24px;
    font-size: 15.5px;
  }

  .home_review_pg_cta {
    width: 100%;
    padding: 15px 24px;
  }

  .home_review_pg_stage {
    padding: 20px 0 0 14px;
  }

  .home_review_pg_card {
    padding: 22px 20px 20px;
    border-radius: 18px;
  }

  .home_review_pg_card_second {
    transform: translate3d(-10px, -10px, 0) rotate(-2deg) scale(0.97);
  }

  .home_review_pg_card_third {
    transform: translate3d(-18px, -18px, 0) rotate(-3.5deg) scale(0.94);
  }

  .home_review_pg_card_hidden {
    transform: translate3d(-24px, -22px, 0) rotate(-4.5deg) scale(0.9);
  }

  .home_review_pg_card_out {
    transform: translate3d(-50px, 10px, 0) rotate(-7deg) scale(0.96);
  }

  .home_review_pg_quote_icon {
    margin-bottom: 12px;
  }

  .home_review_pg_quote {
    margin-bottom: 20px;
    font-size: 15px;
    line-height: 1.65;
  }

  .home_review_pg_avatar {
    width: 40px;
    height: 40px;
    font-size: 15px;
  }

  .home_review_pg_person {
    gap: 12px;
  }

  .home_review_pg_controls {
    gap: 12px;
    margin-top: 24px;
  }

  .home_review_pg_arrow {
    width: 42px;
    height: 42px;
  }

  .home_review_pg_dots {
    gap: 6px;
  }

  .home_review_pg_dot {
    width: 8px;
    height: 8px;
  }

  .home_review_pg_dot_active {
    width: 26px;
  }
}

@media (max-width: 360px) {
  .home_review_pg_container {
    padding: 0 14px;
  }

  .home_review_pg_card {
    padding: 18px 16px 18px;
  }

  .home_review_pg_quote {
    font-size: 14.5px;
  }

  .home_review_pg_count {
    font-size: 11.5px;
  }
}

/* ============================================================
   Reduced motion
   ============================================================ */

@media (prefers-reduced-motion: reduce) {
  .home_review_pg_reveal,
  .home_review_pg_reveal_deck,
  .home_review_pg_step {
    opacity: 1 !important;
    transform: none !important;
    transition: none !important;
  }

  .home_review_pg_card {
    transition: opacity 0.3s ease !important;
  }

  .home_review_pg_card_second,
  .home_review_pg_card_third,
  .home_review_pg_card_hidden,
  .home_review_pg_card_out {
    transform: none !important;
  }

  .home_review_pg_card_second,
  .home_review_pg_card_third {
    opacity: 0 !important;
  }

  .home_review_pg_dot_fill_run {
    animation: none !important;
    width: 100% !important;
  }
}


/* ---- header tab switch: copy + deck fade up again ---- */
.home_review_pg_swap {
  animation: home_review_pg_swap_in 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes home_review_pg_swap_in {
  from { opacity: 0; transform: translateY(18px); }
  to   { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
  .home_review_pg_swap {
    animation: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/HomeReviewPage/HomeReviewPage.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,0EAA0E;EAC1E,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,2FAA2F;EAC3F,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,cAAc;EACd,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,2FAA2F;EAC3F,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,6DAA6D;EAC7D,+CAA+C;EAC/C,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,4BAA4B;EAC5B,0DAA0D;AAC5D;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB,EAAE,0CAA0C;AACpE;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,mFAAmF;EACnF,yBAAyB;EACzB,+BAA+B;EAC/B;;;wBAGsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,UAAU;EACV,UAAU;EACV,qDAAqD;AACvD;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mEAAmE;EACnE,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mEAAmE;EACnE,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,UAAU;EACV,oBAAoB;EACpB,kEAAkE;AACpE;;AAEA,+DAA+D;AAC/D;EACE,UAAU;EACV,UAAU;EACV,oBAAoB;EACpB,gEAAgE;AAClE;;AAEA,+EAA+E;;AAE/E;EACE,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,eAAe;EACf;;kFAEgF;AAClF;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,6DAA6D;EAC7D,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,kCAAkC;AACpC;;AAEA,mCAAmC;;AAEnC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;EAC/C,cAAc;EACd,eAAe;EACf,4FAA4F;EAC5F,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,iEAAiE;AACnE;;AAEA;EACE;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;AACF;;AAEA;;iEAEiE;;AAEjE;EACE,UAAU;EACV,2BAA2B;EAC3B;;+DAE6D;AAC/D;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA,yDAAyD;AACzD;EACE;;;;mBAIiB;AACnB;;AAEA;EACE,UAAU;EACV,wCAAwC;EACxC;;sDAEoD;AACtD;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,qCAAqC;IACrC,aAAa;EACf;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,iEAAiE;EACnE;;EAEA;IACE,mEAAmE;EACrE;;EAEA;IACE,kEAAkE;EACpE;;EAEA;IACE,gEAAgE;EAClE;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;iEAEiE;;AAEjE;EACE;;;IAGE,qBAAqB;IACrB,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;;;;IAIE,0BAA0B;EAC5B;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;AACF;;;AAGA,2DAA2D;AAC3D;EACE,0EAA0E;AAC5E;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ============================================================\n   HomeReviewPage — learner stories with a stacked card deck\n   Prefix: home_review_pg_ · no :root variables · no green\n   ============================================================ */\n\n.home_review_pg_section {\n  position: relative;\n  width: 100%;\n  padding: 88px 0 96px;\n  background: linear-gradient(135deg, #f4edff 0%, #ffffff 46%, #fff2ea 100%);\n  font-family: \"Sora\", \"Manrope\", sans-serif;\n  color: #0f0a2a;\n  overflow: hidden;\n  isolation: isolate;\n}\n\n.home_review_pg_section *,\n.home_review_pg_section *::before,\n.home_review_pg_section *::after {\n  box-sizing: border-box;\n}\n\n/* soft glows */\n.home_review_pg_section::before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  top: -140px;\n  left: -160px;\n  width: 460px;\n  height: 460px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(106, 31, 194, 0.18) 0%, rgba(106, 31, 194, 0) 70%);\n  pointer-events: none;\n}\n\n.home_review_pg_section::after {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  right: -160px;\n  bottom: -160px;\n  width: 520px;\n  height: 520px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(224, 168, 61, 0.24) 0%, rgba(224, 168, 61, 0) 70%);\n  pointer-events: none;\n}\n\n.home_review_pg_container {\n  display: grid;\n  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);\n  align-items: center;\n  column-gap: 72px;\n  max-width: 1240px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n/* ============================================================\n   Left: copy\n   ============================================================ */\n\n.home_review_pg_copy {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  min-width: 0;\n}\n\n.home_review_pg_eyebrow {\n  margin-bottom: 16px;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #4a1a9e;\n}\n\n.home_review_pg_heading {\n  max-width: 520px;\n  margin: 0 0 18px;\n  font-size: clamp(30px, 4vw, 50px);\n  font-weight: 800;\n  line-height: 1.12;\n  letter-spacing: -0.02em;\n  color: #0f0a2a;\n  text-wrap: balance;\n}\n\n.home_review_pg_subtext {\n  max-width: 440px;\n  margin: 0 0 30px;\n  font-size: 16.5px;\n  line-height: 1.7;\n  color: #5d5978;\n}\n\n.home_review_pg_cta {\n  position: relative;\n  padding: 16px 32px;\n  border: 0;\n  border-radius: 10px;\n  background: linear-gradient(100deg, #4a1a9e 0%, #6a1fc2 100%);\n  box-shadow: 0 16px 32px rgba(74, 26, 158, 0.34);\n  font-family: inherit;\n  font-size: 15.5px;\n  font-weight: 800;\n  color: #ffffff;\n  cursor: pointer;\n  overflow: hidden;\n  isolation: isolate;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n/* gold sweep on hover */\n.home_review_pg_cta::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background: linear-gradient(100deg, #e0a83d 0%, #f2c15c 100%);\n  transform: translateX(-101%);\n  transition: transform 0.45s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.home_review_pg_cta:hover {\n  color: #3b003d;\n  transform: translateY(-3px);\n  box-shadow: 0 20px 36px rgba(224, 168, 61, 0.42);\n}\n\n.home_review_pg_cta:hover::before {\n  transform: translateX(0);\n}\n\n.home_review_pg_cta:active {\n  transform: translateY(0) scale(0.97);\n}\n\n.home_review_pg_cta:focus-visible,\n.home_review_pg_arrow:focus-visible,\n.home_review_pg_dot:focus-visible {\n  outline: 3px solid #e0a83d;\n  outline-offset: 3px;\n}\n\n/* ============================================================\n   Right: stacked card deck\n   ============================================================ */\n\n.home_review_pg_stage {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  min-width: 0;\n  max-width: 620px;\n  justify-self: end;\n  padding: 30px 0 0 30px; /* room for the cards peeking out behind */\n}\n\n/* all cards share one grid cell, so the deck is as tall as the tallest card */\n.home_review_pg_deck {\n  display: grid;\n  width: 100%;\n  outline: none;\n  touch-action: pan-y;\n  perspective: 1400px;\n}\n\n.home_review_pg_deck:focus-visible {\n  outline: 3px solid #e0a83d;\n  outline-offset: 8px;\n  border-radius: 24px;\n}\n\n.home_review_pg_card {\n  grid-area: 1 / 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  padding: 30px 34px 28px;\n  border-radius: 22px;\n  background: #ffffff;\n  border: 1px solid rgba(228, 220, 249, 0.9);\n  box-shadow: 0 30px 70px rgba(74, 26, 158, 0.16), 0 3px 10px rgba(74, 26, 158, 0.05);\n  transform-origin: 15% 95%;\n  will-change: transform, opacity;\n  transition:\n    transform 0.95s cubic-bezier(0.22, 1, 0.36, 1),\n    opacity 0.7s ease,\n    box-shadow 0.7s ease;\n}\n\n/* where each card sits in the stack */\n.home_review_pg_card_front {\n  z-index: 4;\n  opacity: 1;\n  transform: translate3d(0, 0, 0) rotate(0deg) scale(1);\n}\n\n.home_review_pg_card_second {\n  z-index: 3;\n  opacity: 0.9;\n  transform: translate3d(-18px, -16px, 0) rotate(-2.2deg) scale(0.97);\n  box-shadow: 0 18px 40px rgba(74, 26, 158, 0.1);\n}\n\n.home_review_pg_card_third {\n  z-index: 2;\n  opacity: 0.55;\n  transform: translate3d(-34px, -30px, 0) rotate(-4.2deg) scale(0.94);\n  box-shadow: 0 12px 28px rgba(74, 26, 158, 0.07);\n}\n\n.home_review_pg_card_hidden {\n  z-index: 1;\n  opacity: 0;\n  pointer-events: none;\n  transform: translate3d(-46px, -40px, 0) rotate(-5.5deg) scale(0.9);\n}\n\n/* the card that just left: slides away to the left and fades */\n.home_review_pg_card_out {\n  z-index: 5;\n  opacity: 0;\n  pointer-events: none;\n  transform: translate3d(-90px, 14px, 0) rotate(-9deg) scale(0.96);\n}\n\n/* ---------- Card content: rises in when a card reaches the front ---------- */\n\n.home_review_pg_step {\n  opacity: 0;\n  transform: translateY(14px);\n  transition: opacity 0.3s ease, transform 0.3s ease;\n}\n\n.home_review_pg_card_front .home_review_pg_step {\n  opacity: 1;\n  transform: none;\n  transition:\n    opacity 0.7s ease calc(var(--s, 0) * 80ms + 280ms),\n    transform 0.8s cubic-bezier(0.22, 1, 0.36, 1) calc(var(--s, 0) * 80ms + 280ms);\n}\n\n.home_review_pg_quote_icon {\n  display: inline-flex;\n  align-self: flex-start;\n  margin-bottom: 18px;\n  color: #f2a900;\n}\n\n.home_review_pg_outcome {\n  align-self: flex-start;\n  margin-bottom: 16px;\n  padding: 5px 13px;\n  border-radius: 999px;\n  background: #ece2ff;\n  font-size: 12px;\n  font-weight: 700;\n  color: #4a1a9e;\n}\n\n.home_review_pg_quote {\n  flex-grow: 1;\n  margin: 0 0 26px;\n  font-size: 17px;\n  line-height: 1.7;\n  text-align: left;\n  color: #1c1538;\n  overflow-wrap: anywhere;\n}\n\n.home_review_pg_person {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.home_review_pg_avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 46px;\n  height: 46px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #4a1a9e 0%, #6a1fc2 100%);\n  box-shadow: 0 8px 18px rgba(74, 26, 158, 0.3);\n  font-size: 17px;\n  font-weight: 800;\n  color: #ffffff;\n}\n\n.home_review_pg_who {\n  flex: 1;\n  min-width: 0;\n}\n\n.home_review_pg_name {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 800;\n  line-height: 1.3;\n  color: #0f0a2a;\n}\n\n.home_review_pg_role {\n  margin: 2px 0 0;\n  font-size: 12.5px;\n  line-height: 1.4;\n  color: #6b6784;\n}\n\n.home_review_pg_count {\n  flex-shrink: 0;\n  font-size: 12.5px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  color: #6b6784;\n  font-variant-numeric: tabular-nums;\n}\n\n/* ---------- Controls ---------- */\n\n.home_review_pg_controls {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  margin-top: 30px;\n}\n\n.home_review_pg_arrow {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 46px;\n  height: 46px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: #ffffff;\n  box-shadow: 0 10px 24px rgba(74, 26, 158, 0.16);\n  color: #1c1538;\n  cursor: pointer;\n  transition: transform 0.3s ease, background 0.3s ease, color 0.3s ease, box-shadow 0.3s ease;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.home_review_pg_arrow:hover {\n  background: #4a1a9e;\n  color: #ffffff;\n  box-shadow: 0 14px 28px rgba(74, 26, 158, 0.34);\n}\n\n.home_review_pg_arrow:active {\n  transform: scale(0.9);\n}\n\n.home_review_pg_dots {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.home_review_pg_dot {\n  position: relative;\n  width: 10px;\n  height: 10px;\n  padding: 0;\n  border: 0;\n  border-radius: 999px;\n  background: #d9ccf3;\n  overflow: hidden;\n  cursor: pointer;\n  transition: width 0.45s cubic-bezier(0.22, 1, 0.36, 1), background 0.3s ease;\n}\n\n.home_review_pg_dot:hover {\n  background: #bba6ea;\n}\n\n.home_review_pg_dot_active {\n  width: 34px;\n  background: #d9ccf3;\n}\n\n/* the active dot doubles as the autoplay timer */\n.home_review_pg_dot_fill {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  border-radius: 999px;\n  background: #4a1a9e;\n}\n\n.home_review_pg_dot_fill_run {\n  width: 0;\n  animation: home_review_pg_timer var(--ms, 6500ms) linear forwards;\n}\n\n@keyframes home_review_pg_timer {\n  from {\n    width: 0;\n  }\n  to {\n    width: 100%;\n  }\n}\n\n/* ============================================================\n   Entrance (plays once when the section scrolls into view)\n   ============================================================ */\n\n.home_review_pg_reveal {\n  opacity: 0;\n  transform: translateY(28px);\n  transition:\n    opacity 0.8s ease var(--d, 0ms),\n    transform 0.9s cubic-bezier(0.22, 1, 0.36, 1) var(--d, 0ms);\n}\n\n.home_review_pg_in .home_review_pg_reveal {\n  opacity: 1;\n  transform: none;\n}\n\n/* the cta keeps its own hover transition once revealed */\n.home_review_pg_in .home_review_pg_cta.home_review_pg_reveal {\n  transition:\n    opacity 0.8s ease var(--d, 0ms),\n    transform 0.3s ease,\n    box-shadow 0.3s ease,\n    color 0.3s ease;\n}\n\n.home_review_pg_reveal_deck {\n  opacity: 0;\n  transform: translateX(60px) rotate(2deg);\n  transition:\n    opacity 0.9s ease 0.3s,\n    transform 1.1s cubic-bezier(0.22, 1, 0.36, 1) 0.3s;\n}\n\n.home_review_pg_in .home_review_pg_reveal_deck {\n  opacity: 1;\n  transform: none;\n}\n\n/* ============================================================\n   Responsive — 1100 / 820 / 560 / 360\n   ============================================================ */\n\n@media (max-width: 1100px) {\n  .home_review_pg_section {\n    padding: 72px 0 80px;\n  }\n\n  .home_review_pg_container {\n    column-gap: 44px;\n  }\n\n  .home_review_pg_card {\n    padding: 26px 26px 24px;\n  }\n\n  .home_review_pg_quote {\n    font-size: 16px;\n  }\n}\n\n/* stack: copy on top, deck below */\n@media (max-width: 900px) {\n  .home_review_pg_section {\n    padding: 60px 0 72px;\n  }\n\n  .home_review_pg_container {\n    grid-template-columns: minmax(0, 1fr);\n    row-gap: 44px;\n  }\n\n  .home_review_pg_heading,\n  .home_review_pg_subtext {\n    max-width: 640px;\n  }\n\n  .home_review_pg_stage {\n    justify-self: center;\n    max-width: 640px;\n    padding: 28px 0 0 28px;\n  }\n\n  .home_review_pg_reveal_deck {\n    transform: translateY(40px);\n  }\n}\n\n@media (max-width: 560px) {\n  .home_review_pg_section {\n    padding: 48px 0 60px;\n  }\n\n  .home_review_pg_container {\n    padding: 0 18px;\n    row-gap: 34px;\n  }\n\n  .home_review_pg_subtext {\n    margin-bottom: 24px;\n    font-size: 15.5px;\n  }\n\n  .home_review_pg_cta {\n    width: 100%;\n    padding: 15px 24px;\n  }\n\n  .home_review_pg_stage {\n    padding: 20px 0 0 14px;\n  }\n\n  .home_review_pg_card {\n    padding: 22px 20px 20px;\n    border-radius: 18px;\n  }\n\n  .home_review_pg_card_second {\n    transform: translate3d(-10px, -10px, 0) rotate(-2deg) scale(0.97);\n  }\n\n  .home_review_pg_card_third {\n    transform: translate3d(-18px, -18px, 0) rotate(-3.5deg) scale(0.94);\n  }\n\n  .home_review_pg_card_hidden {\n    transform: translate3d(-24px, -22px, 0) rotate(-4.5deg) scale(0.9);\n  }\n\n  .home_review_pg_card_out {\n    transform: translate3d(-50px, 10px, 0) rotate(-7deg) scale(0.96);\n  }\n\n  .home_review_pg_quote_icon {\n    margin-bottom: 12px;\n  }\n\n  .home_review_pg_quote {\n    margin-bottom: 20px;\n    font-size: 15px;\n    line-height: 1.65;\n  }\n\n  .home_review_pg_avatar {\n    width: 40px;\n    height: 40px;\n    font-size: 15px;\n  }\n\n  .home_review_pg_person {\n    gap: 12px;\n  }\n\n  .home_review_pg_controls {\n    gap: 12px;\n    margin-top: 24px;\n  }\n\n  .home_review_pg_arrow {\n    width: 42px;\n    height: 42px;\n  }\n\n  .home_review_pg_dots {\n    gap: 6px;\n  }\n\n  .home_review_pg_dot {\n    width: 8px;\n    height: 8px;\n  }\n\n  .home_review_pg_dot_active {\n    width: 26px;\n  }\n}\n\n@media (max-width: 360px) {\n  .home_review_pg_container {\n    padding: 0 14px;\n  }\n\n  .home_review_pg_card {\n    padding: 18px 16px 18px;\n  }\n\n  .home_review_pg_quote {\n    font-size: 14.5px;\n  }\n\n  .home_review_pg_count {\n    font-size: 11.5px;\n  }\n}\n\n/* ============================================================\n   Reduced motion\n   ============================================================ */\n\n@media (prefers-reduced-motion: reduce) {\n  .home_review_pg_reveal,\n  .home_review_pg_reveal_deck,\n  .home_review_pg_step {\n    opacity: 1 !important;\n    transform: none !important;\n    transition: none !important;\n  }\n\n  .home_review_pg_card {\n    transition: opacity 0.3s ease !important;\n  }\n\n  .home_review_pg_card_second,\n  .home_review_pg_card_third,\n  .home_review_pg_card_hidden,\n  .home_review_pg_card_out {\n    transform: none !important;\n  }\n\n  .home_review_pg_card_second,\n  .home_review_pg_card_third {\n    opacity: 0 !important;\n  }\n\n  .home_review_pg_dot_fill_run {\n    animation: none !important;\n    width: 100% !important;\n  }\n}\n\n\n/* ---- header tab switch: copy + deck fade up again ---- */\n.home_review_pg_swap {\n  animation: home_review_pg_swap_in 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n@keyframes home_review_pg_swap_in {\n  from { opacity: 0; transform: translateY(18px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .home_review_pg_swap {\n    animation: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
